import React from "react";

import { getSiteInfo } from "@/sites";
import { getSiteDomain } from "./site";
import { getSvgContent } from "@/actions/getSvgContent";

const getSvgPathFromDomain = () => {
  const domainName = getSiteDomain();
  const { companies, fonts } = getSiteInfo(domainName);

  const fontNames = fonts;
  const companyNames = companies;

  return { fontNames, companyNames };
};

const getNumberFromPart = (part: string) => {
  const key = part.slice(2, -2);
  const number = key.slice(-1);

  return !isNaN(Number(number)) ? Number(number) - 1 : 0;
};

const formatPartKey = (part: string) => {
  const key = part.slice(2, -2);

  // Remove the last character if it's a number, since the SVGs name will always be saved with a number
  // The number will only be used to make the difference in the companies JSON file. Example: in JSON mor_name1, mor_name2...
  // but in the SVGs /font/company/mor_name.svg (it is the company the variable)
  return key.replace(/[0-9]$/, "");
};

export const replacePlaceholdersWithSVGs = async (text: string) => {
  const { companyNames, fontNames } = getSvgPathFromDomain();
  const parts = text.split(/(%%\w+%%)/);
  const filteredParts = parts.filter((part) => part !== "");

  const result = await Promise.all(
    filteredParts.map(async (part) => {
      if (part.startsWith("%%")) {
        const svgContent = await getSvgContent(
          `${fontNames[0]}/${companyNames[getNumberFromPart(part)]}/${formatPartKey(part)}.svg`
        );
        return svgContent;
      }

      return part;
    })
  );

  return <React.Fragment>{result.join("")}</React.Fragment>;
};
